import React from "react";
import TableHeader from './TableHeader.jsx';
import TableBody from './TableBody.jsx';

/**
 * 
 * @param {any} props
 */
const Table = (props) => {

    return (
        <table className="table table-striped bottom-separator-xs">
            <TableHeader 
                data={props.data}
                orderColumn={props.orderColumn} />


            <TableBody data={props.data}
                atlas={props.atlas}
                setearEntidad={props.setearEntidad} />
        </table>
    );
}

export default Table